import Vue from "vue";
import VueRouter from "vue-router";


const Devices = () => import("../views/Devices.vue");
const Channels = () => import("../views/Channels.vue");
const EPG = () => import("../views/Guide.vue");
const Sports = () => import("../views/Sports.vue");
const OnDemand = () => import("../views/OnDemand.vue");
const Game = () => import("../views/Game.vue");

const Channel = () => import("../views/Channel.vue");
const EPGList = () => import("../views/EPGList.vue");
const Sport = () => import("../views/Sport.vue");
const Stations = () => import("../views/Stations.vue");
const OnDemandDetails = () => import("../views/Details.vue");

const Games = () => import("../views/desktop/Games.vue");
const Search = () => import("../views/desktop/Search.vue");

const DesktopWod = () => import("../views/desktop/WOD.vue");
const DesktopHome = () => import("../views/desktop/Home.vue");
const DesktopLive = () => import("../views/desktop/Live.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: DesktopHome,
  },
  {
    path: "/live",
    name: "Live",
    component: DesktopLive,
  },
  {
    path: "/theater",
    name: "Theater",
    component: DesktopWod,
  },

  {
    path: "/channels",
    name: "channels",
    component: Channels,
  },
  {
    path: "/epg",
    name: "EPGList",
    component: EPGList,
  },
  {
    path: "/stations",
    name: "Stations",
    component: Stations,
  },
   {
    path: "/vod",
    name: "VOD",
    component: OnDemand,
  },
  {
    path: "/games",
    name: "Games",
    component: Games,
  },
  {
    path: "/game/:id",
    name: "Game",
    component: Game,
  },
  {
    path: "/search",
    name: "Search",
    component: Search,
  },
  {
    path: "/sports",
    name: "Sports",
    component: Sports,
  },
  {
    path: "/devices",
    name: "Devices",
    component: Devices,
  },
  {
    path: "/movie/:id",
    name: "VODMovieDetailsBookmarks",
    component: OnDemandDetails,
  },
  {
    path: "/tv/:id",
    name: "VODShowDetailsBookmarks",
    component: OnDemandDetails,
  },
  {
    path: "/channel/:id",
    name: "LiveChannelBookmarks",
    component: Channel,
  },
  {
    path: "/guide/:id",
    name: "Guides",
    component: EPG,
  },
  {
    path: "/sport/:sport/:league/:eventId",
    name: "SportView",
    component: Sport,
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});

export default router;
